/* eslint-disable import/no-default-export */
// eslint-disable-next-line no-restricted-imports
import { normalizeBoardStar } from 'app/gamma/src/api/normalizers/board';
// eslint-disable-next-line no-restricted-imports
import type { SocketMemberAction } from 'app/gamma/src/modules/sockets';
// eslint-disable-next-line no-restricted-imports
import { isDeletedModel, SOCKET_MEMBER } from 'app/gamma/src/modules/sockets';
// eslint-disable-next-line no-restricted-imports
import type { BoardStarModel } from 'app/gamma/src/types/models';
// eslint-disable-next-line no-restricted-imports
import { createReducer } from '@trello/redux';

// Action types
// eslint-disable-next-line no-restricted-imports
import type { LoadHeaderSuccessAction } from 'app/gamma/src/modules/loaders/load-header';
// eslint-disable-next-line no-restricted-imports
import { LOAD_HEADER_SUCCESS } from 'app/gamma/src/modules/loaders/load-header';
import type { LoadMyBoardsSuccessAction } from 'app/src/components/ReduxSearch/loadBoardsForSearch';
import { LOAD_MY_BOARDS_SUCCESS } from 'app/src/components/ReduxSearch/loadBoardsForSearch';

const PLACEHOLDER_PREFIX = 'placeholder-';

export const isPlaceholder = (entry: BoardStarModel) => {
  return entry.id.indexOf(PLACEHOLDER_PREFIX) === 0;
};

export type BoardStarState = BoardStarModel[];

// Reducer
const initialState: BoardStarState = [];

export default createReducer(initialState, {
  [LOAD_HEADER_SUCCESS](
    state: BoardStarState,
    { payload }: LoadHeaderSuccessAction,
  ) {
    return payload.boardStars
      ? payload.boardStars.map((star) => normalizeBoardStar(star))
      : [];
  },
  [LOAD_MY_BOARDS_SUCCESS](
    state: BoardStarState,
    { payload }: LoadMyBoardsSuccessAction,
  ) {
    return payload.boardStars
      ? payload.boardStars.map((star) => normalizeBoardStar(star))
      : [];
  },
  [SOCKET_MEMBER](state: BoardStarState, { payload }: SocketMemberAction) {
    if (!isDeletedModel(payload) && payload.boardStars !== undefined) {
      // Keep any optimistic updates, so we have to keep track of which
      // entries are placeholders or marked deleted

      const deletedStars = new Map<string, boolean>();

      state.forEach((entry) => {
        if (entry.deleted === true) {
          deletedStars.set(entry.id, true);
        }
      });

      return [
        ...payload.boardStars.map((entry) => {
          if (deletedStars.get(entry.id)) {
            return { ...entry, deleted: true };
          } else {
            return entry;
          }
        }),
        ...state.filter((entry) => isPlaceholder(entry)),
      ];
    } else {
      return state;
    }
  },
});
